/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ContractDocumentsControllerFindOneQueryResponse, ContractDocumentsControllerFindOnePathParams, ContractDocumentsControllerFindOneQueryParams, ContractDocumentsControllerFindOne400, ContractDocumentsControllerFindOne401, ContractDocumentsControllerFindOne403, ContractDocumentsControllerFindOne404 } from "../../models/contractDocumentsController/ContractDocumentsControllerFindOne";

function getContractDocumentsControllerFindOneUrl(id: ContractDocumentsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/contract-documents/${id}` as const }  
  return res
}

/**
 * @summary Get a contract document
 * {@link /api/v1/contract-documents/:id}
 */
export async function contractDocumentsControllerFindOne(id: ContractDocumentsControllerFindOnePathParams["id"], params?: ContractDocumentsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ContractDocumentsControllerFindOneQueryResponse, ResponseErrorConfig<ContractDocumentsControllerFindOne400 | ContractDocumentsControllerFindOne401 | ContractDocumentsControllerFindOne403 | ContractDocumentsControllerFindOne404>, unknown>({ method : "GET", url : getContractDocumentsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}